export const myScooprConsents = [
  'cc-scoopr-account-summary',
  'cc-scoopr-debt_register_api-summary',
  'cc-scoopr-creditsafe-right_of_access-summary',
];
